export enum DownloadItemStatus {
  QUEUED = 'Queued',
  GENERATING = 'Generating',
  READY = 'Ready',
  FAILED = 'Failed',
  STALE = 'Stale',
}
